<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-text-field v-model="searchValue" label="搜尋"
                      :color="Theme.GREEN" placeholder="查詢公告"></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn class="mr-2" :color="Theme.GREEN" dark @click.prevent="searchEvent">搜尋</v-btn>
        <v-btn :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
      <v-flex>
        <v-spacer></v-spacer>
        <v-btn style="float: right;" :color="Theme.PINK" dark @click.prevent="addNew">新增</v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <table-view :items="list"
                    :columnKeys="getColumnKeys"
                    :pagination="pagination"
                    :loading="loading"
                    @changePage="changePage"
                    @cellEvent="cellEvent"/>
      </v-flex>
    </v-layout>

    <news-detail :title="editView.title" :visible="editView.visible"
                 :item-detail="editView.item"
                 :show-cancel="editView.showCancel"
                 @cancelEvent="editView.cancelEvent"
                 @confirmEvent="editView.confirmEvent">
    </news-detail>
  </v-container>
</template>

<script>
import TableView from "@/components/TableView";

import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";
import NewsDetail from "@/pages/news/NewsDetail";

export default {
  name: "news",
  components: {
    NewsDetail,
    TableView
  },
  mixins: [common],
  data() {
    return {
      loading: false,
      searchValue:'',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list:[],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
      },
    };
  },
  created() {
    this.loadData();
  },
  computed:{
    ...mapGetters([]),
    getColumnKeys(){
      return [
        { value:'edit', text:'編輯' , isEvent: true, color: this.Theme.GREEN, sortable: false },
        { value:'title', text:'標題', sortable: true },
        { value:'subContent', text:'簡介', sortable: false },
        { value:'hidden', text:'隱藏', sortable: false , options: [
            { key: 0, text: '否'},
            { key: 1, text: '是'}
          ]},
        { value:'sort', text:'排序', sortable: false },
        { value:'updatedDate', text:'最後更新時間', sortable: false },
        { value:'delete', text:'刪除' , isEvent: true, color: this.Theme.YELLOW, sortable: false },
      ]
    }
  },
  methods:{
    ...mapActions(['getNewsList','deleteNewsInfo']),
    async loadData(){
      this.loading = true;
      const res = await this.getNewsList({
        pageIndex: this.pagination.page,
        limit: this.pagination.itemsPerPage,
        searchValue:this.searchValue,
        admin: '1',
      });

      if (res.data.code === 0){
        this.list = res.data.body.list;
        this.pagination.totalItems = res.data.body.header.totalCount;

        console.log(`getStoreList ${JSON.stringify(res.data.body.list)}`);
      }
      this.loading = false;
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page){
      this.pagination.page = page.page;
      this.pagination.itemsPerPage = page.itemsPerPage;
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell){
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === 'delete'){
        this.showAlert({
          title: '提示',
          content: '是否確定要刪除此消息？',
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteEvent(cell.item);
          }
        });
      } else {
        this.editView.title = cell.key === 'add' ? '新增消息':'修改消息'
        this.editView.item = cell.item;
        this.editView.visible = true;
        this.editView.cancelEvent = ()=>{
          this.editView.visible = false;
        }
        this.editView.confirmEvent = ()=>{
          this.editView.visible = false;
          this.loadData();
        }
      }

    },
    searchEvent(){
      this.loadData();
    },
    reset(){
      this.searchValue = '';
      this.loadData();
    },
    async deleteEvent(item){
      const res = await this.deleteNewsInfo({
        newsId: item.newsId,
      });

      if (res.data.code === 0){
        this.reset();
      }
    },
    addNew(){
      this.cellEvent({
        key: 'add',
        item: {
          newsId: this.uuid.v4(),
          title:'',
          subContent:'',
          content:'',
          hidden: false,
          sort:0,
          smallURL:'',
          largeURL:'',
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
